<div (click)="navigate()" class="d-flex jc-center ai-center">
  <div class="d-flex jc-center ai-center" [class]="{ makeWhite: logoTheme == 'white' }">
    <img class="logo" [src]="logoUrl" />
  </div>
</div>
